import { render } from "./DeckList.vue?vue&type=template&id=22c25d25&scoped=true"
import script from "./DeckList.vue?vue&type=script&lang=js"
export * from "./DeckList.vue?vue&type=script&lang=js"

import "./DeckList.vue?vue&type=style&index=0&id=22c25d25&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c25d25"]])

export default __exports__